
import React from 'react'
import Footer from '../Footer'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/documentacionAdultoMayor.scss'
import { Link } from "react-router-dom";

export default function DocumentacionAdultoMayor() {

    return (
    <>
     <section className='info-documentacion adulto-mayor'>
                
                {/* HERO */}
                <div className='info-documentacion-hero adulto-mayor-hero'>
                    <div className='overlay'></div>

                    <div className='container'>
                        <div className='hero-content'>

                            <div style={{ marginTop: '4rem' }} style={{ color: '#fff' }}>
                                <Breadcrumbs />
                            </div>

                            <h1>Documentación para personas mayores de 70 años</h1>

                            <p>
                                Información y requisitos necesarios para viajar de forma segura y cómoda
                                en nuestras embarcaciones.
                            </p>

                        </div>
                    </div>
                </div>

                <div className='container'>

                    <div className='info-documentacion-grid'>

                        {/* CONTENIDO */}
                        <div className='info-documentacion-main'>

                            {/* REQUISITOS */}
                            <div className='documentacion-card'>

                                <div className='section-title'>
                                    <i className="fi fi-rs-document-signed"></i>
                                    <h2>Requisitos obligatorios</h2>
                                </div>

                                <div className='documentos-grid'>

                                    <div className='documento-item'>
                                        <div className='icon'>
                                            <i className="fi fi-rs-id-card"></i>
                                        </div>

                                        <div>
                                            <h3>Identificación oficial</h3>

                                            <p>
                                                Presentar identificación oficial vigente con fotografía.
                                            </p>

                                            <div className='documentos-tags'>
                                                <span>INE</span>
                                                <span>Pasaporte</span>
                                                <span>Licencia</span>
                                                <span>Cédula Profesional</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='documento-item'>
                                        <div className='icon'>
                                            <i className="fi fi-rs-doctor"></i>
                                        </div>

                                        <div>
                                            <h3>Certificado médico</h3>

                                            <p> <strong>Este documento es obligatorio únicamente si el pasajero presenta:</strong></p>
                                            <ul>
                                                <li>Enfermedades cardiovasculares, respiratorias, neurológicas o metabólicas no controladas.</li>
                                                <li>Cirugías o procedimientos médicos recientes (últimos 30 días).</li>
                                                <li>Requerimiento de oxígeno, dispositivos médicos o supervisión constante (estos no serán proporcionados por el buque).</li>
                                                <li>Episodios recientes (últimos 6 meses) de desmayos, convulsiones o pérdida de conciencia.</li>
                                                <li>Condiciones que puedan agravarse durante una travesía marítima de 14 horas.</li>
                                                <li>Limitaciones de movilidad (se recomendará al cliente considerar el uso de silla de ruedas y/o acompañante).</li>
                                                <li>Enfermedades infecciosas.</li>

                                            </ul>
                                        </div>
                                    </div>

                                    <div className='documento-item'>
                                        <div className='icon'>
                                            <i className="fi fi-rs-file-signature"></i>
                                        </div>

                                        <div>
                                            <h3>Carta responsiva</h3>

                                            <p>Se firma en terminal <strong>en caso de no contar con certificado médico</strong> y si el personal médico detecta alguna condición adicional no especificada durante la revisión en puerto.                                            </p>

                                            <div className='nota-mini'>
                                                El formato será proporcionado por nuestro equipo en el punto
                                                de venta.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* RECOMENDACIONES */}
                            <div className='documentacion-card'>

                                <div className='section-title'>
                                    <i className="fi fi-rs-lightbulb-on"></i>
                                    <h2>Recomendaciones</h2>
                                </div>

                                <div className='recomendaciones-grid'>

                                    <div className='recomendacion-item'>
                                        <div className='icon-circle'>
                                            <i className="fi fi-rs-user-headset"></i>
                                        </div>

                                        <div>
                                            <h4>Reserva con anticipación</h4>

                                            <p>
                                                Informa a nuestro personal si requieres apoyo especial,
                                                movilidad reducida o asistencia durante el embarque.
                                            </p>
                                        </div>
                                    </div>

                                    <div className='recomendacion-item'>
                                        <div className='icon-circle'>
                                            <i className="fi fi-rs-clock-three"></i>
                                        </div>

                                        <div>
                                            <h4>Llega con tiempo</h4>

                                            <p>
                                                Si no llevas automóvil, recomendamos llegar al menos 1:30 horas antes de la salida para
                                                realizar el proceso de embarque con tranquilidad.
                                            </p>
                                        </div>
                                    </div>

                                    <div className='recomendacion-item'>
                                        <div className='icon-circle'>
                                            <i className="fi fi-rs-medicine"></i>
                                        </div>

                                        <div>
                                            <h4>Medicamentos a la mano</h4>

                                            <p>
                                                Lleva tus medicamentos y prescripciones en el equipaje de mano
                                                durante toda la travesía.
                                            </p>
                                        </div>
                                    </div>

                                    <div className='recomendacion-item'>
                                        <div className='icon-circle'>
                                            <i class="fi fi-rs-info"></i>
                                        </div>

                                        <div>
                                            <h4>Apoyo de tripulación</h4>

                                            <p>
                                                Nuestro personal está capacitado para brindar asistencia en
                                                áreas comunes durante el viaje.
                                            </p>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* SIDEBAR */}
                        <aside className='info-documentacion-sidebar'>

                            <div className='sidebar-card'>

                                <h3>Temas relacionados</h3>

                                <ul className='sidebar-links'>

                                    <li>
                                        <Link to='/viajar-con-menores-de-edad'>
                                            <span>Viajar con menores de edad</span>
                                            <i className="fi fi-rs-arrow-small-right"></i>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to='/viajar-con-auto'>
                                            <span>Documentación para automóvil</span>
                                            <i className="fi fi-rs-arrow-small-right"></i>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to='/viajar-con-mascotas'>
                                            <span>Viajar con mascotas</span>
                                            <i className="fi fi-rs-arrow-small-right"></i>
                                        </Link>
                                    </li>

                                </ul>

                            </div>

                            <div className='sidebar-card ayuda-card'>

                                <h4>¿Necesitas ayuda?</h4>

                                <p>
                                    Nuestro equipo de atención está disponible para resolver cualquier duda
                                    relacionada con tu viaje.
                                </p>

                                <a href="tel:8003377437">
                                    <i className="fi fi-rs-phone-call"></i>
                                    800 337 7437
                                </a>

                                <a href="mailto:contactcenter@bajaferries.com.mx">
                                    <i className="fi fi-rs-envelope"></i>
                                    contactcenter@bajaferries.com.mx
                                </a>

                            </div>

                        </aside>

                    </div>

                </div>

                <Footer />
            </section>
    </>
    )
}
